(function () {
    'use strict';

    angular
        .module('app')
        .factory('global', global);

    global.$inject = ['$location', '$window',];

    function global($location, $window) {
        var service = {
            user: null,
            source: 'web',
            game: null,
            platform: 'desktop',
            isWeb: false,
            isIOS: false,
            isAndroid: false,
            isWSA: false,
            isApp: false,
            isDesktop: false,
            isInternational: false,
            site: 'prod',
            isSafari: $window.navigator.userAgent.indexOf('Safari') !== -1 && $window.navigator.userAgent.indexOf('Chrome') === -1,
        };

        if ($location.search().source) {
            service.source = $location.search().source;
        }

        if ($location.search().game) {
            service.game = $location.search().game;
        }

        if ($location.search().wsa) {
            service.platform = 'wsa';
            service.isWSA = true;
        } else if ($window.navigator && $window.navigator.userAgent) {
            if ($window.navigator.userAgent.indexOf('iPhone') !== -1) {
                service.platform = 'ios:iphone';
                service.isIOS = true;
            } else if ($window.navigator.userAgent.indexOf('iPad') !== -1) {
                service.platform = 'ios:ipad';
                service.isIOS = true;
            } else if ($window.navigator.userAgent.indexOf('iPod') !== -1) {
                service.platform = 'ios:ipod';
                service.isIOS = true;
            } else if ($window.navigator.userAgent.indexOf('Android') !== -1) {
                service.platform = 'android';
                service.isAndroid = true;
            } else {
                service.isDesktop = true;
            }
        } else {
            service.isDesktop = true;
        }

        service.isWeb = service.source === 'web';
        service.isApp = !service.isWeb;

        if ($location.absUrl().indexOf('.se') === -1) {
            service.isInternational = true;
        }

        if ($location.absUrl().indexOf('stage') !== -1) {
            service.site = 'stage';
        }

        return service;
    }

})();